import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./user-session.actions";
const initialState = {
  currentUser: null,
};

export default createReducer(initialState, {
  [actions.setCurrentUser]: createSetter("currentUser"),
  [actions.reset]: () => ({ ...initialState }),
});
